module.exports = __webpack_public_path__ + "static/img/badge-no-spray-active.f4f582a.svg";